import React from 'react';
import NavBar from 'sections/NavBar';
import AboutUs from 'sections/AboutUs';
import Hero from 'sections/Hero';
import Comparison from 'sections/Comparison';
import Testimonial from 'sections/Testimonial';
import ContactUs from 'sections/ContactUs';
import Footer from 'sections/Footer';
import RealTimeNum from 'sections/RealTimeNum';
import BackToTop from 'components/BackToTop'
// import { useWindowScrollPosition } from 'the-platform';

// const sectionIds = ['home', 'features', 'about', 'contact']

function App() {

  // const { y } = useWindowScrollPosition()

  // const [sectionPos, setSectionPos] = React.useState<any>([])
  // React.useEffect(() => {
  //   const sections = sectionIds.map(id => ({
  //     hash: `#${id}`,
  //     y: document?.getElementById(id)?.offsetTop
  //   }))
  //   setSectionPos(sections)
  //   console.log(sectionPos)
  // }, [])


  // React.useEffect(() => {

  //   for(let i = 0; i < sectionPos.length; i++) {
  //     if(y >= sectionPos[i].y && y < (sectionPos[i+1]?.y ?? Number.MAX_SAFE_INTEGER)) {
  //       window.location.hash = sectionPos[i].hash
  //     }
  //   }
  //   eslint-disable-next-line
  // }, [y])


  return (
    <div className="App">
      <NavBar />
      <Hero id='home' />
      <AboutUs id='features'/>
      <Comparison id='about'/>
      <Testimonial />
      <RealTimeNum />
      <ContactUs id='contact'/>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;
